<template>

  <v-row justify="center" class="dialogRedBook">
    <v-dialog  v-model="initialvalue.dialogStatus" style="border: 1px solid #e5e5e5 !important; background: white !important;">
      <v-card v-if="Book.BookObj != null" class="pa-2">
        <v-container >
          <v-row
            no-gutters
            :class="$root.$i18n.locale != 'ar' ? 'rtlStyle' : ''"
            v-if="Book.chapter.length  != 0"
          >
            
            <v-col cols="12" md="3">
              <p class="bookNameStyle">{{versionInfo.bookname}}</p>
              <v-card
                style="overflow: auto; height: 550px; border: 1px solid #b5b5b5"
                class="treeviewChaptar pa-2 ml-3 mt-3"
                elevation="3"
              >
                <v-treeview
                  class="treeview treeviewChaptar"
                  hoverable
                  item-children="subitems"
                  :items="Book.chapter"
                  item-key="id"
                  rounded
                >
                  <template v-slot:prepend="{ item, open }">
                    <v-icon
                      color="#8bc34a"
                      class="mr-2 ml-2 iconChapter"
                      v-if="item.subitems != 0 && item.subitems != undefined"
                    >
                      {{ open ? "mdi-folder-open" : "mdi-folder" }}
                    </v-icon>

                    <v-icon
                      class="mr-2 ml-2 iconChapter"
                      color="#e19090"
                      v-else
                    >
                      {{ (open = "mdi-file-document-outline") }}
                    </v-icon>
                    <a
                      class="chapterLink labelChapter"
                      v-if="!(item.subitems != 0 && item.subitems != undefined)"
                      @click="returnHref(item)"
                      >{{ item.label }}</a
                    >
                    <span class="labelChapter" v-else>{{ item.label }}</span>
                  </template>
                </v-treeview>
              </v-card>
            </v-col>
            <v-col cols="12" md="9">
              <v-row>
                <v-col cols="12" md="8" class="searchSection pb-0">
                  <template>
                    <v-text-field
                      :hide-details="true"
                      class="rounded-0 magnifyIcon mb-2"
                      outlined
                      dense
                      :label="$t('readBook.SearchInThisBook')"
                      background-color="#fff"
                      append-outer-icon="mdi-magnify"
                    >
                      <template v-slot:prepend>
                        <v-menu rig offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              style="height: 40px"
                              elevation="0"
                              v-bind="attrs"
                              v-on="on"
                              color="orange"
                              class="white--text rounded-0 ma-0 pa-0"
                            >
                              <v-icon left> mdi-chevron-down </v-icon>
                            </v-btn>
                          </template>
                        </v-menu>
                      </template>
                    </v-text-field>
                  </template>
                </v-col>
                <v-col cols="6" md="2" class="pb-0"
                  ><v-btn
                    small
                    class="px-1"
                    style="height: 38px ; font-size: 11px;"
                    :disabled="!versionInfo.isdownloadable"
                    color="#8bc34a"
                    outlined
                    @click="DownloadBook(versionInfo)"
                    >{{ $t("readBook.downloadBook") }}</v-btn
                  ></v-col
                >
                <v-col cols="6" md="2" class="pb-0"
                  ><v-btn
                    class="mx-2 px-1"
                    small
                    outlined
                    color="orange"
                    style="height: 38px  ; font-size: 11px;"
                    @click="$router.push({name: 'ReadBook', params: { bookID: initialvalue.bookId }})"
                    >{{ $t("readBook.OpenNewPage") }}</v-btn
                  ></v-col
                >
                <v-col cols="12">
                  <v-card
                    ref="viewer"
                    class="pa-2"
                    style="border: 1px solid #b3b3b3; overflow: auto"
                    height="422px"
                  >
                    <div id="viewer" class="spreads"></div>
                  </v-card>
                  <div class="btmContainer">
                    <v-row no-gutters>
                      <v-col cols="12" class="mb-0 pb-0">
                        <v-slider
                          v-model="itemsSlider.val"
                          :max="pagesListCount"
                          color="#8bc34a"
                          thumb-label
                          hide-details=""
                          @change="ChangePage"
                        ></v-slider>
                      </v-col>
                     <v-col cols="4" class="pa-0 ma-0 pl-2">
                        <v-btn
                          width="100%"
                          small
                          color="primary"
                          class="arrow ma-2 mr-2"
                          @click="prevPage()"
                        >
                          <span class="fas fa-xl mx-2 fa-arrow-circle-right">
                            </span
                          >{{ $t("readBook.prev") }}
                        </v-btn>
                      </v-col>
                      <v-col cols="4" class="pa-0 ma-0">
                        <p style="" class="paginatClass">
                          <span style="border-radius: 6px 0px 0px 6px">{{
                            itemsSlider.val
                          }}</span>
                          <span style="border-radius: 0px 6px 6px 0px">{{
                            pagesListCount
                          }}</span>
                        </p>
                      </v-col>
                       <v-col cols="4" class="pa-0 ma-0">
                        <v-btn
                          width="100%"
                          small
                          color="primary"
                          class="arrow mt-2"
                          @click="nextPage()"
                        >{{ $t("readBook.next") }}
                          <span
                            class="fas fa-xl fa-arrow-circle-left mr-2"
                          ></span>
                          
                        </v-btn>
                      </v-col>


                      
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-card class="pa-2" elevation="0" v-else>
            <v-skeleton-loader
              type="table-heading, list-item-two-line, image, table-tfoot"
            ></v-skeleton-loader>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import Book from "epubjs";
import axios from "axios";
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      initialvalue: this.value,
      itemsSlider: { val: 1, color: "primary" },
      Book: {
        BookObj: null,
        rendition: null,
        url: "",
        chapter: [],
        versionInfo: "",
      },
      hrefLink: "",
      indexPage: 0,
      uploadedBook: false,
      pagesList: [],
      pagesListCount: 0,
      reloadOpenBook: false,
    };
  },
  //   components: { Navbar },

  watch: {
    hrefLink: function (val) {
      this.Book.rendition.display(val);
    },
    pagesList: function (val) {
      this.pagesListCount = val.length;
      if(this.initialvalue.href){
         this.itemsSlider.val = this.pagesList.findIndex(i => i.href === this.initialvalue.href) +1 
      }
    },
    "initialvalue.dialogStatus": function (val) {
      this.reloadOpenBook = !this.reloadOpenBook;
      this.Book= {
            BookObj: null,
            rendition: null,
            url: "",
            chapter: [],
            versionInfo: "",
        }
      if (val == true) {
          this.itemsSlider.val = 0
          
        this.getVersionInfo();
      }
      //   console.log(this.reloadOpenBook)
    },
  },
  mounted() {
    this.getVersionInfo();
  },
  methods: {
    ChangePage() {
      this.Book.rendition.display(this.pagesList[this.itemsSlider.val]["href"]);
    },
    getVersionInfo() {
        
      this.$store
        .dispatch("GetFromAPI", "/guest/book/" + this.initialvalue.bookId)
        .then((response) => {
          this.versionInfo = response.data.data;
          this.Book.url = this.versionInfo.fileurl;
          this.getBook();
        })
        .catch((error) => {
          this.$store.dispatch("PushErrorMsg", error.data.data);
          this.uploadedBook = true;
        });
    },
    getBook() {
      this.Book.BookObj = new Book(this.Book.url);
      this.Book.rendition = this.Book.BookObj.renderTo("viewer", {
        flow: "scrolled-doc",
        width: "100%",
        spread: "always",
        minSpreadWidth: "100%",
      });

      this.Book.rendition.display();
      this.Book.rendition.themes.default({"p": { "font-size": "20px !important"}, ".span_micro" :{ "color": "orange" }, ".a_micro" :{ "text-decoration": "none" }}  )
     
      this.Book.BookObj.loaded.navigation.then((nav) => {
        this.uploadedBook = true;
        this.Book.chapter = nav.toc;
      });
      this.Book.BookObj.loaded.resources.then((list) => {
        this.pagesList = list.resources;
      });
      this.Book.rendition.hooks.content.register(this.UpdateBookContent);
      if(this.initialvalue.href){
        this.Book.rendition.display(this.initialvalue.href)
      }
    },
    UpdateBookContent(contents) {
      this.loadingAdd = true;
      let DataForm = {
        Param: {
          bookID: this.initialvalue.bookId,
          versionID: this.initialvalue.bookId,
          HTMLcontent: contents.content.innerHTML,
        },
        API: "/admin/microprocess",
      };
      this.$store
        .dispatch("PostToAPI", DataForm)
        .then((response) => {
          this.loadingAdd = false;
          if (response.data.success == true) {
            //console.log (response.data.data.HTMLcontent)
            contents.content.innerHTML = response.data.data.HTMLcontent;
          }
        //   console.log(
        //     this.$refs.bookElement
        //       .getElementsByTagName("iframe")[0]
        //       .setAttribute("class", "democlass")
        //   );
        })
        .catch(() => {
          this.loadingAdd = false;
        });
    },

    nextPage() {
      this.Book.rendition.next();
      this.itemsSlider.val =
        this.pagesList.findIndex(
          (i) => i.href === this.Book.BookObj.rendition.location.start.href
        ) + 1;
      this.$nextTick(() => {
        this.$refs.viewer.$el.scrollTop = 0;
      });
    },
    prevPage() {
      this.Book.rendition.prev();
      this.itemsSlider.val =
        this.pagesList.findIndex(
          (i) => i.href === this.Book.BookObj.rendition.location.start.href
        ) - 1;
      this.$nextTick(() => {
        this.$refs.viewer.$el.scrollTop = 0;
      });
    },
    returnHref(val) {
      this.itemsSlider.val = this.pagesList.findIndex(
        (i) => i.href === val.href
      );
      this.hrefLink = val.href;
    },
      DownloadBook(selectedBookFromList){

      // console.log(selectedBookFromList)
      // // return

      axios({
        url: selectedBookFromList.fileurl,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        let DataForm = {
          API : `/guest/book/${selectedBookFromList.bookid}/download`
        }
        this.$store.dispatch("PostToAPI", DataForm)
        
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", selectedBookFromList.bookname + ".epub");
        document.body.appendChild(link);
        link.click();
      });


      // window.open(this.versionInfo.fileurl)
    },
    openPDFBook() {
      // console.log("Open PDF");
    },
  },
};
</script>